<div class="videos-carousel carousel">
  <!-- carousel header -->
  <div class="carousel-header">
    <div class="carousel-header__content">
      <h2 class="carousel-title" i18n="@@title.videos">Videos</h2>
    </div>
    <!-- end carousel header -->
    <!-- arrows -->
    <div class="arrows">
      <button [id]="arrowLeftCssSelector" class="arrow arrow-left">
        <ush-arrow [template]="arrowTemplate" orientation="left"></ush-arrow>
      </button>
      <button [id]="arrowRightCssSelector" class="arrow arrow-right">
        <ush-arrow [template]="arrowTemplate" orientation="right"></ush-arrow>
      </button>
    </div>
    <!-- end arrows -->
  </div>
  <div class="videos-carousel__content">
    <!-- movies carousel -->
    @if (videoItems && videoItems.length > 0) {
      <swiper-container #swiper ushSwiperElement [config]="swiperConfig" init="false">
        <swiper-slide *ngFor="let video of videoItems">
          <ui-video-card [video]="video"></ui-video-card>
        </swiper-slide>
      </swiper-container>
    }
  </div>
</div>
